/** Every key that moves the handle; releasing one commits the value. */
export const SLIDER_KEYS = [
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'PageUp',
    'PageDown',
    'Home',
    'End',
];

const FORWARD_KEYS = ['ArrowRight', 'ArrowUp', 'PageUp'];
const ARROW_KEYS = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
const PAGE_STEPS = 2;

interface Range {
    min: number;
    max: number;
    step: number;
}

function decimals(step: number): number {
    const fraction = String(step).split('.')[1];
    return fraction ? fraction.length : 0;
}

function clamp(value: number, { min, max }: Range): number {
    return Math.min(max, Math.max(min, value));
}

/**
 * The value a key the slider handles itself moves to: a page key moves two steps and an
 * arrow with Shift moves one, where Radix would move ten. `undefined` leaves the key to Radix.
 */
export function nextKeyValue(
    event: { key: string; shiftKey: boolean },
    value: number,
    range: Range
): number | undefined {
    const isPage = event.key === 'PageUp' || event.key === 'PageDown';
    const isShiftArrow = event.shiftKey && ARROW_KEYS.includes(event.key);
    if (!isPage && !isShiftArrow) return undefined;

    const direction = FORWARD_KEYS.includes(event.key) ? 1 : -1;
    const steps = isPage ? PAGE_STEPS : 1;
    const next = Number((value + direction * steps * range.step).toFixed(decimals(range.step)));
    return clamp(next, range);
}

/** Where each step sits along the rail, as a percentage from the start. */
export function tickPercentages(min: number, max: number, step: number): number[] {
    if (!(max > min) || !(step > 0)) return [];
    const count = Math.floor((max - min) / step + 1e-9);
    return Array.from({ length: count + 1 }, (_, index) => ((index * step) / (max - min)) * 100);
}
